export default __webpack_public_path__ + "f79f421923551778bbfb4bd2cd258574.png";